import CodingCoursePage from "./codingCoursePage"

export default CodingCoursePage;